module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iqRXF"))).then(() => parcelRequire('3a9aZ'));